function isEnabled(value) {
  if (value === true || value === 1 || value === '1') return true
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase()
    return (
      normalized === 'true' || normalized === 'yes' || normalized === 'on'
    )
  }
  if (value && typeof value === 'object' && value.value !== undefined) {
    return isEnabled(value.value)
  }
  return false
}

function parseXFields(xfields) {
  if (!xfields) return null
  if (typeof xfields === 'object') return xfields
  try {
    const parsed = JSON.parse(xfields)
    return parsed && typeof parsed === 'object' ? parsed : null
  } catch (error) {
    return null
  }
}

export function readXFieldVisibility(record) {
  const xfields = parseXFields(record && record.xfields)
  if (!xfields) return null

  const laravelData = xfields.laravel_data
  if (laravelData && typeof laravelData.value === 'string') {
    try {
      const parsed = JSON.parse(laravelData.value)
      if (parsed && parsed.visibility !== undefined) return parsed.visibility
    } catch (error) {
      return null
    }
  }

  if (laravelData && laravelData.visibility !== undefined) {
    return laravelData.visibility
  }

  if (xfields.visibility !== undefined) return xfields.visibility
  return null
}

export function visibilityMapFromProducts(products) {
  const map = {}
  ;(products || []).forEach((product) => {
    const uuid = product && (product.uuid || product.product_uuid)
    const value = readXFieldVisibility(product)
    if (!uuid || value === null || value === undefined) return
    map[String(uuid).toUpperCase()] = isEnabled(value)
  })
  return map
}
